/** @format */

import React, { useState, useRef, useEffect } from "react";
import style from "./index.module.scss";
import cn from "classnames";

const CustomInputWithUnits = ({
  onChangeValue = () => void 0,
  onChangeUnit = () => void 0,
  inputType = "number",
  isDisabled = false,
  isBgGray = false,
  value = "",
  units = {},
  selectedUnit = "",
  showIcon = false,
  showDropdownArrow = true,
  showUnitCode = false,
  paddingLeft = "",
  prefixStart = "",
  maxLength = "",
  placeholder = "",
  labelText = "",
  errorText = "",
  onKeyPress = () => {},
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const unitButtonRef = useRef(null);

  const currentUnit = units[selectedUnit] || Object.values(units)[0] || {};

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  const getValue = (event) => {
    let newValue = event.target.value;

    if (inputType === "number") {
      newValue = newValue ? Number(newValue) : "";
    }

    onChangeValue(newValue);
  };

  const handleUnitSelect = (unitCode) => {
    const selectedUnitData = {
      code: unitCode,
      ...units[unitCode],
    };

    onChangeUnit(selectedUnitData);
    setDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        unitButtonRef.current &&
        !unitButtonRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const hasMultipleUnits = Object.keys(units).length > 1;

  return (
    <div style={{ width: "100%" }}>
      <div className={style.wrapper}>
        {prefixStart && <span className={style.prefixStart}>{prefixStart}</span>}

        <label
          className={cn(style.labelInp, {
            [style.focusedLabel]: isFocused,
            [style.labelError]: errorText,
          })}
        >
          {labelText}
        </label>

        <input
          type={inputType}
          className={cn(style.input, {
            [style.input_pdLeft40]: prefixStart,
            [style.input_pdRight]: true,
            [style.input_disabled]: isDisabled,
            [style.input_bg_wgray]: isBgGray,
            [style.input_errorState]: errorText,
          })}
          readOnly={isDisabled}
          disabled={isDisabled}
          value={value}
          placeholder={placeholder}
          onChange={getValue}
          maxLength={maxLength}
          onWheel={(event) => event.target.blur()}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
        />

        {Object.keys(units).length > 0 && (
          <div
            ref={unitButtonRef}
            className={style.currencySelector}
            onClick={() => hasMultipleUnits && !isDisabled && setDropdownOpen(!dropdownOpen)}
          >
            {showIcon && currentUnit.icon && (
              <span style={{ marginRight: "4px", fontSize: "14px" }}>{currentUnit.icon}</span>
            )}

            <span className={style.currencySymbol}>{currentUnit.symbol || selectedUnit}</span>

            {showDropdownArrow && hasMultipleUnits && <span className={style.currencyArrow}>▼</span>}
          </div>
        )}

        {dropdownOpen && hasMultipleUnits && (
          <div ref={dropdownRef} className={style.currencyDropdown}>
            {Object.entries(units).map(([code, unit]) => (
              <div
                key={code}
                className={cn(style.currencyOption, {
                  [style.currencyOptionSelected]: code === selectedUnit,
                })}
                onClick={() => handleUnitSelect(code)}
              >
                {showIcon && unit.icon && (
                  <span style={{ marginRight: "8px", fontSize: "16px" }}>{unit.icon}</span>
                )}

                <span className={style.currencySymbol}>{unit.symbol || code}</span>

                {showUnitCode && code && (
                  <span className={style.currencyCode} style={{ marginLeft: "8px" }}>
                    {code}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomInputWithUnits;
